import { render, staticRenderFns } from "./StockView.vue?vue&type=template&id=0801abb9&"
import script from "./StockView.vue?vue&type=script&lang=js&"
export * from "./StockView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports